<template>
  <v-autocomplete
    color="primary"
    v-model="materialsSelected"
    :clearable="!unclearable"
    :items="materialsItems"
    :loading="materialsLoading"
    :search-input.sync="materialsSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Material.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    autofocus
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
    <template v-if="errorHint" v-slot:message="{ key, message }">
      <div :class="key == 0 ? 'danger--text' : ''">
        {{ message }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SupplierMaterials from "@/api/supplier_materials";

export default {
  name: "SearcherMaterial",

  props: {
    value: Object,
    materialCategories: Array,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    hint: String,
    errorHint: Boolean,
  },

  computed: {
    materialsItems() {
      var materials;
      if (this.materialCategories && this.materialCategories.length > 0) {
        materials = this.materials.filter((material) =>
          this.materialCategories.find(
            (cat) => cat.code == material.category_code
          )
        );
      } else {
        materials = this.materials;
      }
      return materials.map((e) => {
        const Description = this.settings
          ? this.settings.material_name_display_type == 3
            ? i18n.t("Material.materialNameWithCodeAndStandard", [
                e.material.material_code,
                e.material.material_name,
                e.standard.name,
              ])
            : this.settings.material_name_display_type == 2
            ? i18n.t("Material.materialNameWithCode", [
                e.material.material_code,
                e.material.material_name,
              ])
            : i18n.t("Material.materialName", [e.material.material_name])
          : i18n.t("Material.materialName", [e.material.material_name]);
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.material_id == e.material_id
            )
          : false;
        return Object.assign({}, e, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    materials: [],
    materialsLoading: false,
    materialsSearch: "",
    materialsSelected: null,
  }),

  mounted() {
    this.materialsLoading = true;
    SupplierMaterials.fetchAllForSelect({})
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials;
            // if (this.$route.params.id) {
            //   let result = this.materials.filter((v) => {
            //     return v.id == this.$route.params.id;
            //   });
            //   this.materialsSelected = result[0];
            // }
            // if (this.$route.query.material_id) {
            //   let res = this.materials.filter((v) => {
            //     return v.id == this.$route.query.material_id;
            //   });
            //   this.materialsSelected = res[0];
            // }
          }
          this.materialsLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.materialsLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialsSelected = this.value;
      },
    },
    materialsSelected: {
      handler() {
        this.$emit("input", this.materialsSelected);
      },
    },
  },
};
</script>
